app.controller("TwoFactorAuthController", ["$scope", "AuthService", "$state", "$timeout",
    function ($scope, AuthService, $state, $timeout) {
        $scope.userId = AuthService.userId || localStorage.getItem('userId');
        $scope.code = '';
        //$scope.status;
        //$scope.errorText;
        $scope.clicked = false;

        $scope.goBack = function () {
            $state.go("login");
        };

        $scope.submit = function () {
            $scope.status = '';

            if ($scope.code && $scope.code.length === 6) {
                AuthService.verifyTwoFactor({
                    token: $scope.code
                }).then(function (data) {
                    if (data.status === 'fail') {
                        $scope.status = 'error';
                        $scope.errorText = 'დაცული კოდი არასწორია!';
                    } else {
                        $state.go("profile");
                    }
                }).catch(function (err) {
                    console.error(err);
                });

            } else {
                $scope.status = 'error';
                $scope.errorText = 'გთხოვთ სწორად მიუთითოთ დაცული კოდი';
            }
        }

    }
]);
